import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createGlobalStyle } from 'styled-components';
import fonts from 'src/integration/styles/fonts';
import colors from 'src/integration/styles/colors';
import InputCalendar from 'src/presentation/components/ui/InputCalendar';

interface ComponentProps {
  selectedDate: Date;
  onChange: (date: Date | null) => void;
}

const CustomStyles = createGlobalStyle`
  .react-datepicker {
    font-family: ${fonts.fontFamily.headings};
    border-radius: 12px;
    border: 1px solid ${colors.grey4};
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .react-datepicker__header {
    background-color: ${colors.primaryWhite};
    border-bottom: 1px solid ${colors.grey3};
  }

  .react-datepicker__day {
    color: ${colors.primaryDarkJungleGreen};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 2px;
  }

  .react-datepicker__day--selected {
    background-color: ${colors.primaryNewCar};
    color: ${colors.primaryWhite};
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${colors.grey3};
    color: ${colors.primaryDarkJungleGreen};
  }

  .react-datepicker__day--disabled {
    color: ${colors.grey3};
  }

  .react-datepicker__day--today {
    font-weight: 700;
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${colors.primaryDarkJungleGreen};
  }

  .react-datepicker__navigation--next--disabled .react-datepicker__navigation-icon::before {
    border-color: ${colors.grey3};
  }

  .react-datepicker__navigation--next--disabled {
    cursor: default;
  }
`;

const StyledDatePicker = ({selectedDate, onChange} : ComponentProps) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <>
      <CustomStyles />
      <DatePicker
        selected={selectedDate}
        onChange={(date: Date | null) => onChange(date)}
        customInput={<InputCalendar />}
        placeholderText="Select a date"
        dateFormat="yyyy-MM-dd"
        calendarStartDay={1}
        maxDate={today}
        filterDate={(date: Date) => date <= today}
      />
     </>
  );
};

export default StyledDatePicker;
